
// Loader.tsx
import React from 'react';
import './Loader.scss';


const Loader: React.FC<any> = ({isTableLoader}) => {
  return (
    <div className={isTableLoader ? "loader-container table-loader": "loader-container "} data-testid="loader">
      <div className="loader"  ></div>
    </div>
  );
};

export default Loader;

